export default __webpack_public_path__ + "static/portalalianzas-banner-fdfbaa01528c6759c17d7ed36920e863.png";